import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { assetsRestReadThunk } from '../../thunks/assets_thunks';
import { Button, Divider, Popover, Select, Space } from 'antd';
import AssetNumberDisplay from '../asset_row_display/AssetNumberDisplay';
import { checkIsWarrantyActive, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ROLE_TYPES } from '../../utils/DataConstants';

const AssetWorkOrderSelect = ({
	assets,
	onChange,
	fetchAssets,
	additionalFilters,
	fetchMultipleAssets,
	...props
}) => {
	const [showingAll, setShowingAll] = React.useState(false);
	return (
		<OWAsyncSelect
			{...props}
			style={{ maxWidth: 800 }}
			stateSlice={assets}
			allowClear={true}
			targetCollectionName="WORK_ORDER_FORM_ASSETS_AUTOCOMPLETE"
			fetchMultiple={(ids, targetCollectionName) => {
				fetchMultipleAssets(ids, targetCollectionName);
			}}
			onChange={onChange}
			fetchData={(
				searchText,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			) =>
				fetchAssets(
					{ search: searchText },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			}
			renderRecord={(asset) => (
				<Select.Option key={asset.id} value={asset.id}>
					<div className="flex flex-row items-center">
						<div>{asset.name}</div>
						<AssetNumberDisplay asset={asset} style={{ marginLeft: 12 }} />
						{checkIsWarrantyActive(nullSafeGet('warranties.0', asset)) ? (
							<span className="ml-2 inline-block text-gray-400">(Warranty)</span>
						) : null}
					</div>
				</Select.Option>
			)}
			additionalFilters={{
				...additionalFilters,
				problemTypeId: showingAll ? undefined : additionalFilters.problemTypeId,
			}}
			dropdownRender={(menu) => (
				<>
					{menu}

					<>
						<Divider style={{ margin: '8px 0' }} />
						<Space style={{ padding: '0 8px 4px' }}>
							<Button
								type="text"
								icon={
									<Popover
										overlayStyle={{ zIndex: 1060 }}
										content={
											showingAll
												? 'Click to see all assets for selected location and problem type'
												: 'Click to see all assets for selected location irrespective of problem type'
										}
									>
										<InfoCircleOutlined translate="" />
									</Popover>
								}
								onClick={() => {
									setShowingAll(!showingAll);
								}}
							>
								{showingAll ? 'Hide' : 'Show All'}
							</Button>
						</Space>
					</>
				</>
			)}
			sortBy={{ sort_by: 'name', order: 'ascend' }}
		/>
	);
};

const mapStateToProps = (state: any) => ({
	assets: state.assets,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetsRestReadThunk(
				ownProps.userType,
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAssets: (ids, targetCollectionName) =>
		dispatch(assetsRestReadThunk(ownProps.userType, { ids }, targetCollectionName)),
});

const ComponentWithoutUserType = connect(mapStateToProps, mapDispatchToProps)(AssetWorkOrderSelect);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
